import { OtpAuthForm } from '../components/OtpAuthForm'

export function LoginPage() {
	return <OtpAuthForm mode="login" />
}
